import { LicenseInfoTypeFragment } from '@entities/billing';

export type ModalLicenseUnpaidType = LicenseInfoTypeFragment & {
  isChecked: boolean;
};

export const getModalUnpaidLicenseItem = (
  item: LicenseInfoTypeFragment,
  toEnableAutorenewal: string[]
): ModalLicenseUnpaidType => {
  const isInEnableAutorenewal = toEnableAutorenewal.indexOf(item.id) > -1;
  const isChecked = isInEnableAutorenewal || item.autoRenewal;

  return {
    ...item,
    isChecked,
  };
};
